"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
class ProjectAsset {
    constructor({ url, option, uploadedSummary, fileIds, }) {
        this.toJSON = () => ({
            url: this.url,
            option: this.option,
            uploadedSummary: this.uploadedSummary && this.uploadedSummary,
            fileIds: this.fileIds ? this.fileIds : null,
        });
        this.url = url;
        this.option = option;
        this.uploadedSummary = uploadedSummary;
        this.fileIds = fileIds;
    }
    static fromJSON(json) {
        const { url, option, uploadedSummary, fileIds } = Object.assign({}, json);
        if (typeof url !== 'string')
            throw new Error('.url must be a string');
        if (typeof option !== 'string')
            throw new Error('.option must be a string');
        if (fileIds !== undefined && !Array.isArray(fileIds))
            throw new Error('.fileIds must be an array');
        return new ProjectAsset({
            url,
            option,
            uploadedSummary,
            fileIds: fileIds ? immutable_1.List(fileIds) : null,
        });
    }
}
exports.default = ProjectAsset;
